var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEmoji = function SvgEmoji(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#6C6C89",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M9.997 18.33a8.333 8.333 0 1 0 0-16.666 8.333 8.333 0 0 0 0 16.667"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#6C6C89",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M6.664 12.5a4.16 4.16 0 0 0 3.333 1.667 4.16 4.16 0 0 0 3.334-1.667M12.497 6.664s-.833.833-.833 1.667a1.563 1.563 0 0 1 2.5 0M7.503 6.664s.833.833.833 1.667a1.563 1.563 0 0 0-2.5 0"
  })));
};
export default SvgEmoji;